import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Perfil from './Pefil';

interface PerfilTableProps {
  data: Perfil[];
  columns: TableColumn<Perfil>[];
  customStyles: Record<string, any>;
}

const PerfilTable: React.FC<PerfilTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Perfil>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default PerfilTable;